import { useQuery } from '@tanstack/react-query';
import { statusApi } from './api';

const RECHECK_WHILE_DOWN_MS = 10_000;

/**
 * Whether the API (and its database) answers. Checked once per load and on window focus; while down it re-checks
 * every 10 s so the banner clears by itself when the server comes back.
 */
export function useApiHealth() {
  const query = useQuery({
    queryKey: ['health'],
    queryFn: statusApi.health,
    retry: 1,
    staleTime: 60_000,
    refetchInterval: (q) => (q.state.status === 'error' ? RECHECK_WHILE_DOWN_MS : false),
  });
  return { down: query.isError, checking: query.isFetching };
}
